import { Fragment } from 'react';

import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';
import PlusIcon from '@usas/ui-web/components/icons/PlusIcon';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import { formatDate, formatDateTimeTwelveHourClock, formatSubmittedDateTimeTwelveHourClock } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeDetailTableRow = ({ teamEntryMeetInfo, teamEntry, onView, onEdit, onDeleteClicked, onAdd }) => {
  return (
    <tr>
      <td>{teamEntry?.isReadOnly === true ? <a href='' onClick={(e) => onView(e, teamEntryMeetInfo, teamEntry)}>{teamEntry?.omeMeetName || ''}</a> : <span>{teamEntry?.omeMeetName || ''}</span>}</td>
      <td>{teamEntry?.meetEntryStartDate ? formatDateTimeTwelveHourClock(teamEntry?.meetEntryStartDate) : ''} {teamEntry?.meetEntryStartDate ? "-" : ''} {teamEntry?.meetEntryEndDate ? formatDateTimeTwelveHourClock(teamEntry?.meetEntryEndDate) : ''}</td>
      <td>{teamEntry?.timeZone || ''}</td>
      <td>{teamEntry?.teamEntryStatus || ''} {teamEntry?.orgUnitSubmissionDatetime ? '- ' + formatSubmittedDateTimeTwelveHourClock(teamEntry?.orgUnitSubmissionDatetime) + ' ' + teamEntry?.timeZone : ''}</td>
      <td>
        {teamEntry?.omeMeetOrgUnitEntryId > 0 ?
          <span>
            {(teamEntry?.teamEntryCurrentlyAllowed === true || teamEntry?.teamEntryChangesCurrentlyAllowed === true) &&
              <button className={global.IconButtonMargin} type="button" onClick={(e) => onEdit(e, teamEntryMeetInfo, teamEntry)}><EditIcon /></button>}
            {teamEntry?.teamEntryDeleteCurrentlyAllowed === true &&
              <button className={global.IconButtonMargin} type="button" onClick={(e) => onDeleteClicked(e, teamEntryMeetInfo, teamEntry)}><DeleteIcon /></button>}
          </span>
          :
          <Fragment>
            {teamEntry?.teamEntryCurrentlyAllowed === true &&
              <button className={global.IconButtonMargin} type="button" onClick={(e) => onAdd(e, teamEntryMeetInfo, teamEntry)}><PlusIcon toolTipText='Enter OME Meet' /></button>}
          </Fragment>}
      </td>
    </tr>
  )
};

const LargeDetailTable = ({ teamEntryMeetInfo, teamEntryArray, onView, onEdit, onDeleteClicked, onAdd }) => {
  return (
    <table className={global.DetailTable}>
      <thead>
        <tr>
          <th>OME Meet Name</th>
          <th style={{ minWidth: '305px' }}>Entry Start - End Dates</th>
          <th style={{ minWidth: '180px' }}>Time Zone</th>
          <th style={{ minWidth: '130px' }}>Team Entry Status</th>
          <th style={{ minWidth: '100px' }}></th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(teamEntryArray) && teamEntryArray.length > 0 &&
          teamEntryArray.map((teamEntry, i) =>
            <LargeDetailTableRow
              key={i}
              teamEntryMeetInfo={teamEntryMeetInfo}
              teamEntry={teamEntry}
              onView={onView}
              onEdit={onEdit}
              onDeleteClicked={onDeleteClicked}
              onAdd={onAdd}
            />)}
      </tbody>
    </table>
  );
};

const LargeGrid = ({ arrayData, onAdd, onEdit, onDeleteClicked, onView }) => (
  <table className={[global.UsasTable, 'visible-lg visible-md'].join(' ')}>
    <thead>
      <tr>
        <th>Meet Name</th>
        <th style={{ minWidth: '125px' }}>Meet Host</th>
        <th style={{ minWidth: '180px' }}>Meet Start - End Dates</th>
        <th style={{ minWidth: '125px' }}>Team Name</th>
      </tr>
    </thead>
    <tbody>
      {arrayData.map((teamEntry, i) => {
        return (
          <Fragment key={i}>
            <tr key={i}>
              <td>{teamEntry?.meetName || ''}</td>
              <td>{teamEntry?.meetHost || ''}</td>
              <td>{teamEntry?.startDate ? formatDate(teamEntry?.startDate) : '?'} - {teamEntry?.endDate ? formatDate(teamEntry?.endDate) : '?'}</td>
              <td>{teamEntry?.orgUnitName || ''} {teamEntry?.orgUnitName === 'Unattached' ? (teamEntry?.parentOrgUnitName ? '- ' + teamEntry?.parentOrgUnitName : '') : ''} {teamEntry?.parentOrgUnitCode ? '(' + teamEntry?.parentOrgUnitCode + ')' : ''}</td>
            </tr>
            {
              Array.isArray(teamEntry?.teamEntry) && teamEntry?.teamEntry?.length > 0 &&
              <tr className={global.Expanded}>
                <td colSpan="4">
                  <LargeDetailTable
                    teamEntryMeetInfo={teamEntry}
                    teamEntryArray={teamEntry?.teamEntry}
                    onView={onView}
                    onEdit={onEdit}
                    onDeleteClicked={onDeleteClicked}
                    onAdd={onAdd}
                  />
                </td>
              </tr>
            }
          </Fragment>
        )
      })}
    </tbody>
  </table>
);

const SmallDetailTableRow = ({ teamEntryMeetInfo, teamEntry, onView, onEdit, onDeleteClicked, onAdd }) => {
  return (
    <Fragment>
      <div className={global.SmallDetailTableRow}>
        <div className={global.SmallTableDetailRowHead}>
          {teamEntry?.isReadOnly === true ? <span /> : <span className='hidden-xs'>{teamEntry?.omeMeetName || <span>&nbsp;</span>}</span>}{teamEntry?.isReadOnly === false && <span>&nbsp;</span>}
          {teamEntry?.omeMeetOrgUnitEntryId > 0
            ? <span>
              {teamEntry?.isReadOnly === true &&
                <div style={{ maxWidth: '180px' }}><ActionIntraPageButton onClick={(e) => onView(e, teamEntryMeetInfo, teamEntry)}>View</ActionIntraPageButton></div>}
              {teamEntry?.teamEntryDeleteCurrentlyAllowed === true &&
                <Fragment>
                  {teamEntry?.isReadOnly === true && <span>&nbsp;</span>}
                  <button className={global.IconButton} type="button" onClick={(e) => onDeleteClicked(e, teamEntryMeetInfo, teamEntry)}><DeleteIcon /></button>
                </Fragment>}
              {(teamEntry?.teamEntryCurrentlyAllowed === true || teamEntry?.teamEntryChangesCurrentlyAllowed === true) &&
                <Fragment>
                  {teamEntry?.teamEntryDeleteCurrentlyAllowed === true ?
                    <button className={global.IconButtonMobileMargin} type="button" onClick={(e) => onEdit(e, teamEntryMeetInfo, teamEntry)}><EditIcon /></button> :
                    <Fragment>
                      {teamEntry?.isReadOnly === true && <span>&nbsp;</span>}
                      <button className={global.IconButton} type="button" onClick={(e) => onEdit(e, teamEntryMeetInfo, teamEntry)}><EditIcon /></button>
                    </Fragment>}
                </Fragment>}
            </span>
            :
            <Fragment>
              {teamEntry?.teamEntryCurrentlyAllowed === true &&
                <button className={global.IconButton} type="button" onClick={(e) => onAdd(e, teamEntry)}> <PlusIcon toolTipText='Enter OME Meet' /> </button>}
            </Fragment>}
        </div>
        <div className={global.SmallTableRowInfo}>
          <div className='row'>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>OME Meet Name</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{teamEntry?.omeMeetName || <span>&nbsp;</span>}</div>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Entry Start Date</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{teamEntry?.meetEntryStartDate === null ? <span>&nbsp;</span> : formatDateTimeTwelveHourClock(teamEntry?.meetEntryStartDate)}</div>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Entry End Date</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{teamEntry?.meetEntryEndDate === null ? <span>&nbsp;</span> : formatDateTimeTwelveHourClock(teamEntry?.meetEntryEndDate)}</div>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Time Zone</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{teamEntry?.timeZone || <span>&nbsp;</span>}</div>
            <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Team Entry Status</div>
            <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{teamEntry?.teamEntryStatus || <span>&nbsp;</span>} {teamEntry?.orgUnitSubmissionDatetime ? '- ' + formatSubmittedDateTimeTwelveHourClock(teamEntry?.orgUnitSubmissionDatetime) + ' ' + teamEntry?.timeZone : ''}</div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

const SmallDetailTable = ({ teamEntryMeetInfo, teamEntryArray, onView, onEdit, onDeleteClicked, onAdd }) => {
  return (
    <div className={global.SmallDetailTable}>
      {Array.isArray(teamEntryArray) && teamEntryArray.length > 0 &&
        teamEntryArray.map((teamEntry, i) =>
          <SmallDetailTableRow
            key={i}
            teamEntryMeetInfo={teamEntryMeetInfo}
            teamEntry={teamEntry}
            onView={onView}
            onEdit={onEdit}
            onDeleteClicked={onDeleteClicked}
            onAdd={onAdd}
          />)}
    </div>
  );
};

const SmallGrid = ({ arrayData, onAdd, onEdit, onDeleteClicked, onView }) => (
  <div className={[global.SmallTable, 'hidden-lg hidden-md'].join(' ')}>
    {arrayData.map((teamEntry, i) => {
      return (
        <div className={global.SmallTableRow} key={i}>
          <div className={global.SmallTableRowHead} key={i}>{teamEntry?.isReadOnly === true ? <span /> : <span className='hidden-xs'>{teamEntry?.meetName || ''}</span>}{(teamEntry?.teamEntryDeleteCurrentlyAllowed === true || teamEntry?.teamEntryCurrentlyAllowed === true || teamEntry?.teamEntryChangesCurrentlyAllowed === true) && <span>&nbsp;</span>}&nbsp;
          </div>
          <div className={global.SmallTableRowInfo}>
            <div className='row'>
              {teamEntry?.isReadOnly === true ?
                <span>
                  <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Meet Name</div>
                  <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>{teamEntry?.meetName || <span>&nbsp;</span>}</div>
                </span> :
                <span>
                  <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Meet Name</div>
                  <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{teamEntry?.meetName || <span>&nbsp;</span>}</div>
                </span>
              }
              <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Meet Name</div>
              <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{teamEntry?.meetName || <span>&nbsp;</span>}</div>
              <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Meet Host</div>
              <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>{teamEntry?.meetHost || <span>&nbsp;</span>}</div>
              <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Meet Start Date</div>
              <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>{teamEntry?.startDate ? formatDate(teamEntry?.startDate) : <span>&nbsp;</span>}</div>
              <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Meet End Date</div>
              <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>{teamEntry?.endDate ? formatDate(teamEntry?.endDate) : <span>&nbsp;</span>}</div>
              <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Team Name</div>
              <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>{teamEntry?.orgUnitName || <span>&nbsp;</span>} {teamEntry?.orgUnitName === 'Unattached' ? (teamEntry?.parentOrgUnitName ? '- ' + teamEntry?.parentOrgUnitName : '') : ''} {teamEntry?.parentOrgUnitCode ? '(' + teamEntry?.parentOrgUnitCode + ')' : ''}</div>
            </div>
          </div>
          <SmallDetailTable teamEntryMeetInfo={teamEntry} teamEntryArray={teamEntry?.teamEntry} onView={onView} onEdit={onEdit} onDeleteClicked={onDeleteClicked} onAdd={onAdd} />
        </div>)
    })}
  </div>
);

const TeamEntryGrid = ({ state, onAdd, onEdit, onDeleteClicked, onView }) => {
  if (Array.isArray(state.arrayData) === false || state.arrayData?.length === 0) {
    return (
      <Fragment>
        <div className="row">
          <div className="col-xs-12">
            <p>0 Search Results</p>
          </div>
        </div>
        <table className={[global.UsasTable, 'visible-lg visible-md'].join(' ')}>
          <thead>
            <tr>
              <th>Meet Name</th>
              <th>Meet Host</th>
              <th>Meet Start - End Dates</th>
              <th>Team Entry Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="5">No Results</td>
            </tr>
          </tbody>
        </table>
        <div className={[global.SmallTable, 'hidden-lg hidden-md'].join(' ')}>
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>
              &nbsp;
            </div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Results</div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          {state.arrayData.length > 499
            ? <p className={global.ErrorMessage}>More than 500 Search Results returned. Please add additional filters to narrow your search results.</p>
            : <p>{state.arrayData.length === 1 ? `${state.arrayData.length} Search Result` : `${state.arrayData.length} Search Results`}</p>}
        </div>
      </div>
      <LargeGrid arrayData={state.arrayData} onAdd={onAdd} onEdit={onEdit} onDeleteClicked={onDeleteClicked} onView={onView} />
      <SmallGrid arrayData={state.arrayData} onAdd={onAdd} onEdit={onEdit} onDeleteClicked={onDeleteClicked} onView={onView} />
    </Fragment>
  );
}
export default TeamEntryGrid;